module.exports = __webpack_public_path__ + "static/media/quantium.7671f8f6.svg";